import type { ConversationItem } from '@vivport/backend/types';
import { SquarePen } from 'lucide-react';

type ComposeDraftReadyItem = Extract<ConversationItem, { kind: 'compose_draft_ready' }>;

export interface ProvenanceComposeDraftReadyChipProps {
  item: ComposeDraftReadyItem;
}

export function ProvenanceComposeDraftReadyChip({ item }: ProvenanceComposeDraftReadyChipProps) {
  const subject = item.subject.trim();
  return (
    <div className="inline-flex items-center gap-2 text-xs text-muted-foreground">
      <SquarePen className="h-3.5 w-3.5 shrink-0" />
      <span className="min-w-0 truncate">
        Drafted a message{subject ? `: ${subject}` : ''}
      </span>
    </div>
  );
}
